import { message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  ButtonItem,
  InputItem,
  ErrorItem,
} from "../../../../Components/Items";

class AgregarCirugia extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible) {
        this.consultarTodo();
    }
  }

  onFinishFailed(e) {
    ErrorItem(e);
  };

  consultarTodo() {
    this.setState({ loading: true });
    axios
      .post(
        "cirugias/selectDatosParaCirugia",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          this.formRef.current.setFieldsValue({codigo: res.data.nuevoCodigo})
        } else {
          message.error("No se encontro informacion");
        }
      });
  }

  onFinish(values) {
    if (values?.nombre) {
      this.setState({ loading: true });
      axios
        .post(
          "cirugias/agregarCirugia",
          {
            ...values,
            empresaId: this.props.empresaId,
          },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          this.setState({ loading: false });
          if (res.data.success === 2) {
            message.success("Cirugia agregada exitosamente");
            this.cerrarAgregarCirugia();
          } else if (res.data.success === 1) {
            message.error("No se pudo agregar la cirugia");
          } else {
            message.error("Sucedió un error y no se pudo agregar la cirugia");
          }
        })
        .catch((error) => {
          this.setState({ loading: false });
          message.error("Error al comunicarse con el servidor");
        });
    } else {
      message.info("Proporcione al menos el nombre de la cirugia");
    }
  }
  

  cerrarAgregarCirugia = () => {
    this.props.cerrarAgregarCirugia();
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
  };

  render() {
    return (
      <ModalItem
        title="Agregar Cirugía"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarAgregarCirugia.bind(this)}
      >
        <Form
          ref={this.formRef}
          name="modalAgregarCirugia"
          layout
          bottom={
            <ButtonItem
              type="primary"
              htmlType="submit"
              style={{ display: "block", margin: "0 0 0 auto" }}
              loading={this.state.loading}
            >
              Guardar
            </ButtonItem>
          }
          
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
            
          <FormItem
            name="codigo"
            label="Número de Cirugia"
            required
            margin
          >
            <InputItem disabled placeholder="Ingresa el número de Cirugia" />
          </FormItem>


          <FormItem
            name="nombre"
            label="Cirugía"
            required
            margin
          >
            <InputItem placeholder="Ingresa el tipo de cirugía" />
          </FormItem>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(AgregarCirugia);
